// Shared marketing-param definitions for the redirect-based sign-in flow (SIM-11 / ACS-4135).
// EXTRACTED from useReturnUrl.js so the choke-point (navigateToSignIn) and the /signin reader
// (useReturnUrl) share ONE definition of the keys (drift prevention). No behavior change.
//
// Marketing (BR-018) + referral (BR-043) params carried through the sign-in redirect.
const MARKETING_KEYS = ['campaign', 'referral'];
const STORAGE_KEY = 'signin_return_marketing_params';
// Cap oversized/malformed marketing values so a crafted param cannot bloat the URL.
const MAX_PARAM_LEN = 512;

/**
 * Read the preserved marketing params (campaign/referral) from a URL search string, applying the
 * shared length cap. Over-length or absent values are dropped. Never throws.
 * @param {string} [search] - The URL search string (e.g. '?campaign=spring'). Defaults to the current
 *                            browser location search when omitted (browser-only; '' during SSR).
 * @returns {Object} The preserved marketing params (possibly empty).
 */
const readMarketingParamsFromUrl = search => {
    const rawSearch = typeof search === 'string' ? search : typeof window !== 'undefined' ? window.location.search : '';
    const params = new URLSearchParams(rawSearch);
    const preserved = {};

    MARKETING_KEYS.forEach(key => {
        const value = params.get(key);

        if (value && value.length <= MAX_PARAM_LEN) {
            preserved[key] = value;
        }
    });

    return preserved;
};

export {
    MARKETING_KEYS, STORAGE_KEY, MAX_PARAM_LEN, readMarketingParamsFromUrl
};
